import React from 'react';
import Categories from '../../components/spravochniki/category/Categories'

function Page(props) {
    return (
        <>
          <Categories />
        </>
    );
}

export default Page;